import React, { useState, useLayoutEffect, useEffect } from 'react'
import { Spin, Tooltip } from 'antd'
import { useNavigate } from 'react-router-dom'
import Icon from 'meinian-package/src/component/icon'
import logo from 'image/logo_icon.png'
import Pro2 from 'image/detail/pro2.png'
import util from 'meinian-package/src/utils/util'
import { request } from 'meinian-package/src/utils'
import emitter, { EmitterEvents } from 'meinian-package/src/utils/emitter'
import InsCollMoreAction from 'component/waterfall.card/inspiration/insCollMoreAction'
import createInspiration from 'meinian-package/src/component/useFunModal/createInspiration'
import FirstTooltip from 'meinian-package/src/component/firstTooltip'
import isIPad from 'meinian-package/src/common/isIPad'
import classNames from 'classnames'
import { ossImg } from 'meinian-package/src/utils/image'
import PanelCardList from '../../../../component/cardList/panelCardList'
import styles from './index.module.less'

export default ({ style }) => {
  const history = useNavigate()
  const [width, setWidth] = useState(0)
  const defaultParams = {
    rankStatus: -2,
    queryType: 3,
    topFirstStatus: 1,
    start: 0,
    pageSize: 20,
  }
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([{ label: '新建灵感集', type: 'createInspiration' }])

  useEffect(() => {
    const subCreateIns = () => { fetchData() }
    fetchData()
    emitter.on(EmitterEvents.fastAccess, subCreateIns)
    return () => {
      emitter.off(EmitterEvents.fastAccess, subCreateIns)
    }
  }, [])

  const fetchData = () => {
    try {
      setLoading(true)
      request.post('/zhikuan/ins/inspiration/list-inspiration', defaultParams).then((res) => {
        const _resultList = [{ label: '新建灵感集', type: 'createInspiration' }].concat(res.resultList)
        setData(_resultList)
        setLoading(false)
      })
    } catch (err) {
      setLoading(false)
    }
  }

  useLayoutEffect(() => {
    const onResize = () => {
      const innerWidth = document.body.clientWidth >= 1024 ? document.body.clientWidth : 1024
      const currentWidth = innerWidth - 48 - 80
      setWidth(currentWidth)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])
  return <div className={styles['mn-common-inspiration']} style={style}>
    <div className="mn-common-inspiration-header-title">
      <div className="left-content">常用灵感集</div>
      <div
        className="right-content fill-grey-bg"
        onClick={() => {
          util.track('mn-workbench-click', {
            module1: '快捷入口',
            module2: '常用灵感集',
            module3: '全部灵感集',
          })
          history('/home/coll')
        }}
      >
        全部灵感集 <Icon type="m-Vxing_you" />
      </div>
    </div>
    <Spin tip="Loading..." spinning={loading}>
      <div className="mn-common-inspiration-header-list">
        <PanelCardList
          itemMinWidth={238}
          columnCount={isIPad ? 3 : 5}
          maxColumnCount={6}
          width={width}
          options={data}
          renderCard={({ data: itemData, style: cardStyle }) => <div style={cardStyle}>
            {itemData.type === 'createInspiration' ? <CreateInspirationCard
              onInit={() => fetchData()}
              style={cardStyle}
            /> : <CommonInspirationCard
              itemData={itemData}
              cardStyle={cardStyle}
              onInit={() => fetchData()}
            />}
          </div>}
        />
      </div>
    </Spin>
  </div>
}

const CreateInspirationCard = ({ onInit, style }) => {
  return <FirstTooltip
    contentWidth={259}
    text="灵感集是用于存放款式图片的云文件夹，点此马上创建属于你的灵感集吧！"
    keyValue="mn-first-tip-create-inspiration"
    getPopupContainer={triggerNode => triggerNode.parentElement}
  >
    <div
      className="mn-common-inspiration-content-btn fill-white-bg"
      style={style}
      onClick={() => {
        util.track('mn-workbench-click', {
          module1: '快捷入口',
          module2: '常用灵感集',
          module3: '新建灵感集',
        })
        createInspiration({
          trackSource: '工作台新建',
          onChange: () => onInit()
        })
      }}
    >
      <Icon type="m-xinjianlingganji" className="mn-common-inspiration-content-btn-icon" />
      <div className="mn-common-inspiration-content-btn-text">新建灵感集</div>
    </div>
  </FirstTooltip>
}

const CommonInspirationCardMask = ({ itemData, onInit }) => {
  return <div className={styles['mn-common-inspiration-item-mask']}>
    <div className="mn-common-inspiration-item-mask-action-wrap">
      <Tooltip placement="top" title="新标签页打开">
        <div
          className="mn-common-inspiration-item-mask-action-link"
          onClick={(e) => {
            e.stopPropagation()
            window.open(`/meinian/home/coll/detail/${itemData.id}?inspirationId=${itemData.id}&tab=${itemData.isDataAnalysis ? 4 : ''}`)
          }}
        >
          <Icon type="m-xinbiaoqianye" className="mn-common-inspiration-item-mask-action-link-icon" />
        </div>
      </Tooltip>
      <div onClick={(e) => e.stopPropagation()}>
        <InsCollMoreAction
          loginUserInfo={itemData.loginUserInfo}
          isQuickAccess={itemData.isQuickAccess}
          shareStatus={itemData.shareStatus}
          id={itemData.id}
          name={itemData.name}
          onDelete={onInit}
          onChange={onInit}
          getPopupContainer={triggerNode => triggerNode}
        />
      </div>
    </div>
  </div>
}

const CommonInspirationCard = ({ itemData, cardStyle, onInit }) => {
  const history = useNavigate()
  return <CommonInspirationBaseCard
    style={{
      cursor: 'pointer',
      ...cardStyle,
    }}
    itemData={itemData}
    onClick={() => {
      history(`/home/coll/detail/${itemData.id}?inspirationId=${itemData.id}&tab=${itemData.isDataAnalysis ? 4 : ''}`)
      util.track('mn-workbench-click', {
        module1: '快捷入口',
        module2: '常用灵感集',
        module3: '各灵感集',
      })
    }}
  >
    <CommonInspirationCardMask itemData={itemData} onInit={onInit} />
  </CommonInspirationBaseCard>
}

export const CommonInspirationBaseCard = ({ className = null, itemData = {}, style = null, children = null, onClick = null, imgStyle = {} }) => {
  return <div
    className={classNames(styles['mn-common-inspiration-item'], className)}
    style={style}
    onClick={onClick}
  >
    {((itemData?.coverImgUrl || (itemData?.lastBlogList && itemData?.lastBlogList?.[0])))
      ? <span
          style={{
            backgroundImage: `url(${ossImg(itemData?.coverImgUrl || ((itemData.lastBlogList && itemData.lastBlogList.length) ? itemData.lastBlogList[0].mainUrl : ''), 128, 128)})`,
            ...imgStyle
          }}
          className={styles['mn-common-inspiration-item-img']}
      /> : <div className={styles['mn-common-inspiration-item-img-empty-wrap']} style={imgStyle}>
        <img src={logo} className={styles['mn-common-inspiration-item-empty-img']} />
      </div>}
    <div className={styles['mn-common-inspiration-item-coll-info']}>
      <div className="name clickable text-overflow" title={itemData.name}>{itemData.isPro === 1 && <img src={Pro2} className="coll-info-img" />}{itemData.name}</div>
      <div className="detail">
        <span className="detail-blogNum">款式<span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>{itemData.blogNum}</span></span>
        <span className="detail-line" />
        <span className="detail-ownerName">{itemData.ownerName}</span>
      </div>
    </div>
    {children}
  </div>
}
